import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { normalizeTraitButNot } from 'src/data/toneOfVoice';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    classification: PropTypes.bool.isRequired,
    reason: PropTypes.string.isRequired,
    trait: PropTypes.shape({
      trait: PropTypes.string.isRequired,
      butNot: PropTypes.string,
    }),
  }).isRequired,
  analyzerToneOfVoice: PropTypes.shape({}).isRequired,
  onApplyToneOfVoice: PropTypes.func,
  applyingAnalyzedToneOfVoice: PropTypes.string,
  readOnly: PropTypes.bool,
};

const defaultProps = {
  className: null,
  onApplyToneOfVoice: null,
  applyingAnalyzedToneOfVoice: null,
  readOnly: false,
};

export const ToneOfVoiceInsightsItem = ({
  className,
  item,
  analyzerToneOfVoice,
  onApplyToneOfVoice,
  applyingAnalyzedToneOfVoice,
  readOnly,
}) => {
  const styles = useStyles();

  const handleClick = () => {
    onApplyToneOfVoice({
      toneOfVoice: analyzerToneOfVoice,
      trait: item.trait,
      butNot: item.trait.butNot,
    });
  };

  const isApplyingTrait = applyingAnalyzedToneOfVoice === item.trait.trait;

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph14}>{item.reason}</CustomTypography>

      {onApplyToneOfVoice && !readOnly && (
        <CustomButton
          className={styles.buttonApply}
          variant={CUSTOM_BUTTON_VARIANT.outlined}
          onClick={handleClick}
          disabled={!!applyingAnalyzedToneOfVoice}
          loading={isApplyingTrait}
        >
          Make <span>{item.trait.butNot ? 'less' : 'more'} </span>
          <span>
            {item.trait.butNot ? normalizeTraitButNot(item.trait.butNot) : item.trait.trait}
          </span>
        </CustomButton>
      )}
    </div>
  );
};

ToneOfVoiceInsightsItem.propTypes = propTypes;
ToneOfVoiceInsightsItem.defaultProps = defaultProps;
